import { PinInput, Skeleton } from '@gravity-ui/uikit';

import styles from '../styles.module.scss';

export const Loader = () => {
	return (
		<div className={styles.container}>
			<div className={styles.info}>
				<div className={styles.info__title}>
					<Skeleton className={styles.info__title} style={{ width: '360px', height: '24px' }} />
					<Skeleton className={styles.info__title} style={{ width: '82px', height: '24px' }} />
				</div>

				<div className={`${styles.info__block} ${styles.problem_description}`}>
					<div className={styles.info__block__problem}>
						<div>
							<Skeleton className={styles.info__title} style={{ width: '16px', height: '24px' }} />
						</div>
						<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
							<Skeleton className={styles.info__title} style={{ width: '263px', height: '24px' }} />
							<Skeleton className={styles.info__title} style={{ width: '263px', height: '24px' }} />
							<Skeleton className={styles.info__title} style={{ width: '176px', height: '24px' }} />
						</div>
					</div>
					<div className={styles.info__block__rows}>
						<div className={`${styles.info__row} ${styles.short}`}>
							<Skeleton style={{ width: '187px', height: '24px' }} />
							<Skeleton style={{ width: '88px', height: '44px' }} />
						</div>
						<div className={`${styles.info__row} ${styles.short}`}>
							<Skeleton style={{ width: '249px', height: '24px' }} />
							<Skeleton style={{ width: '88px', height: '44px' }} />
						</div>
						<Skeleton style={{ width: '71px', height: '24px' }} />
						<div className={`${styles.info__row} ${styles.mkf}`}>
							<Skeleton style={{ width: '74px', height: '24px' }} />
							<Skeleton style={{ width: '192px', height: '44px' }} />
						</div>
						<div className={`${styles.info__row} ${styles.mkf}`}>
							<Skeleton style={{ width: '190px', height: '24px' }} />
							<PinInput disabled size="xl" />
						</div>
					</div>
				</div>

				<Skeleton style={{ width: '240px', height: '24px', paddingBottom: '8px' }} />

				<div className={`${styles.info__row} ${styles.top}`}>
					<Skeleton style={{ width: '186px', height: '44px', alignSelf: 'flex-start' }} />
					<Skeleton style={{ width: '585px', height: '86px' }} />
				</div>
				<div className={`${styles.info__row} ${styles.top}`}>
					<Skeleton style={{ width: '186px', height: '44px', alignSelf: 'flex-start' }} />
					<Skeleton style={{ width: '585px', height: '86px' }} />
				</div>
				<div className={styles.info__btn_group}>
					<Skeleton style={{ width: '232px', height: '44px' }} />
					<Skeleton style={{ width: '285px', height: '44px' }} />
				</div>
			</div>

			<div className={styles.help__list}>
				<Skeleton style={{ width: '265px', height: '60px' }} />
			</div>
		</div>
	);
};
